angular.module('tasks')
    .component('taskList', {
        bindings: {
            page: '<',
            statistics: '<',
            filters: '<',
        },
        templateUrl: 'app/task/list.html',
        controller: function ($scope, $state, TaskService, DocumentType, TaskStatus, UserGroup){
            this.TaskService = TaskService;

            this.reset = () => this.filters = {};

            this.$onInit = () => {
                DocumentType.query({doc: "task"}).$promise.then(items => this.documentTypes = items);
                TaskStatus.list().$promise.then(items => this.statuses = items);
            }
            this.refreshUserGroups = q => UserGroup.autocomplete({q: q}).$promise.then(items => this.userGroups = items);
            this.getDuration = (startTime, endTime) => {
                if (startTime === null || endTime === null)
                    return "";
                return moment.preciseDiff(startTime, endTime);
            };

            $scope.$on('task.updated', () => $state.reload());
            $scope.$on('task.deleted', () => $state.reload());
        }
    })
